import { styled } from "styled-components";

const Form = styled.form`
    display: flex;
    flex-direction: column;
`;

const Formulario = ({ children, onSubmit }) => {
    return (
        <Form onSubmit={onSubmit}>
            {children}
        </Form>
    );
};

export default Formulario;